export const baseTooltipStackKey = Symbol('baseTooltipStack');
